<template>
  <CFooter fixed style="background-color:#2E2E2E;border-color:#2E2E2E; height:38px;" >
    <div class="row" style="width:100%">
        <div class="col-6 text-left">
          <a href="https://aumhum.com" target="_blank" style="color:#717171; ">Aumhum </a>
          <span class="ml-1" style="color:#717171; ">&copy; {{new Date().getFullYear()}}</span> 
        </div>
         <div class="col-6 text-right">
           <a href="https://www.aumhum.com/about" id="footer" style="color:#717171; ">About Us</a> &nbsp;|&nbsp;
          <a href="https://www.aumhum.com/terms" id="footer" style="color:#717171; ">Terms and Conditions</a> &nbsp;|&nbsp;
          <a href="https://www.aumhum.com/privacy" id="footer" style="color:#717171; ">Privacy</a> &nbsp;|&nbsp;
          <a href="https://help.aumhum.com/hc/en-us/categories/900000147106-Subscription-Billing" id="footer" style="color:#717171; ">Refunds | Cancellations</a> &nbsp;|&nbsp;
          <a href="https://help.aumhum.com/hc/en-us/categories/900000147106-Subscription-Billing" id="footer" style="color:#717171; ">Pricing</a>
        </div>
    </div>
    <!-- <div style="color:#717171; text-align:center; width:100%">
      <a href="https://aumhum.com" target="_blank" style="color:#717171; ">Aumhum </a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>&nbsp;|&nbsp;
      <a href="https://www.aumhum.com/about" id="footer" style="color:#717171; ">About Us</a> &nbsp;|&nbsp;
			<a href="https://www.aumhum.com/terms" id="footer" style="color:#717171; ">Terms and Conditions</a> &nbsp;|&nbsp;
			<a href="https://www.aumhum.com/privacy" id="footer" style="color:#717171; ">Privacy</a> &nbsp;|&nbsp;
			<a href="https://help.aumhum.com/hc/en-us/categories/900000147106-Subscription-Billing" id="footer" style="color:#717171; ">Refunds | Cancellations</a> &nbsp;|&nbsp;
			<a href="https://help.aumhum.com/hc/en-us/categories/900000147106-Subscription-Billing" id="footer" style="color:#717171; ">Pricing</a>
    </div> -->
    
  </CFooter>
</template>

<script>
export default {
  name: 'TheDarkFooter'
}
</script>
